// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"caret-left-small","fill":"currentColor","d":"M14.5 6.5L14.5 17.5L9 12L14.5 6.5Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-caret-left-small')
export default class CaretLeftSmallIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'caret-left-small',
    }
  }
}
